import { PackEditorCallbacks } from "../core/EditorTypes";
import { Pack } from "../Types";
import { EditableText } from "./EditableText";
import { EditableTextMulti } from "./EditableTextMulti";
import { TagsEditor } from "./TagsEditor";

const unixTimestampToReadableString = (unixTimestamp: number) => {
  const date = new Date(unixTimestamp);
  return date.toLocaleString();
};

export function PackInfoEditor(
  props: {
    pack: Pack;
    updatePackField: (field: string, value: any) => void;
    packEditorCallbacks: PackEditorCallbacks;
  },
) {
  const { pack, packEditorCallbacks } = props;

  return (
    <div className="padding" style={{ backgroundColor: "#fff" }}>
      <div className="tiny-header">
        TITLE
      </div>
      <input
        type="text"
        value={pack.metadata.name}
        className="title"
        // @ts-ignore
        onChange={(e) => props.updatePackField("name", e.target.value)}
      />
      <div className="tiny-header">
        UNIQUE IDENTIFIER
      </div>
      <input
        type="text"
        value={pack.metadata.id}
        className="subtitle"
        // @ts-ignore
        onChange={(e) => props.updatePackField("id", e.target.value)}
      />
      <div className="tiny-header">
        DESCRIPTION
      </div>
      <EditableTextMulti
        values={Array.isArray(pack.extra?.description)
          ? pack.extra?.description ?? [""]
          : [pack.extra?.description || ""]}
        write={(value) => props.updatePackField("description", value)}
      />
      <div className="tiny-header">
        VERSION
      </div>
      <EditableText
        write={(value) => props.updatePackField("version", value)}
        value={pack.metadata.version}
      />
      <div className="tiny-header">
        TAGS
      </div>
      <TagsEditor
        tags={pack.metadata.tags}
        packEditorCallbacks={packEditorCallbacks}
      />
    </div>
  );
}

export function PackInfoView(
  props: { pack: Pack },
) {
  const { pack } = props;

  return (
    <div className="padding">
      <p
        style={{
          border: "1px dotted #000",
          borderRadius: 8,
          padding: "0.5em",
          opacity: 0.66,
        }}
      >
        {pack.data.concepts.length} concepts<br />
        {Object.keys(pack.data.reps).length} representations
        {pack.metadata.updated && (
          <>
            <br />
            <br />
            <div>
              <span className="tiny-header">LAST UPDATED</span>
              &nbsp;&nbsp;{unixTimestampToReadableString(pack.metadata.updated)}
            </div>
          </>
        )}
      </p>
    </div>
  );
}
